import { useLobbyParams } from "@shared/hooks/lobby/lobby";
import { root } from "@shared/utils";
import { camelCase, startCase } from "lodash-es";
import React, { memo } from "react";
import { useIntl } from "react-intl";
import Modal from "react-modal";

const BREAK_LENGTH = 25;
const DEFAULT_ROWS_TEXTAREA = 5;

interface IContactsModalProps {
  onClose?: () => void;
  isOpen: boolean;
}

export const ContactsModal: React.FC<IContactsModalProps> = memo(
  ({ isOpen, onClose }) => {
    const intl = useIntl();
    const [isOpenModal, setIsOpenModal] = React.useState<boolean>(isOpen);
    const lobbyParams = useLobbyParams();

    const contactsText = lobbyParams?.contacts ?? "";

    const getRowsCount = () => {
      let rowsCount = 0;
      const newLinesCount = contactsText.split("\n");

      if (newLinesCount.length > 0) {
        rowsCount += newLinesCount.length;
      }

      rowsCount += contactsText.length / BREAK_LENGTH;
      return rowsCount > 1 ? rowsCount : DEFAULT_ROWS_TEXTAREA;
    };

    const onCloseModal = () => {
      setIsOpenModal(false);
      onClose && onClose();
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ModalComponent = Modal as any;

    return (
      <ModalComponent
        isOpen={isOpenModal}
        contentLabel="Contacts Modal"
        overlayClassName="contacts-modal__overlay"
        className="contacts-modal__content"
        appElement={root as HTMLElement}
        onRequestClose={onCloseModal}
      >
        <h1 className="contacts-modal__title">
          {startCase(
            camelCase(
              intl.formatMessage({
                id: "boilerplate.components.ModalContacts.title",
              })
            )
          )}
        </h1>
        <textarea
          value={contactsText}
          rows={getRowsCount()}
          disabled={true}
          className="contacts-modal__textarea"
        />
        <div
          className="contacts-modal__button btn btn--secondary btn--lg object__btn"
          onClick={onCloseModal}
        >
          {intl.formatMessage({
            id: "boilerplate.components.GameMessage.Link",
          })}
        </div>
        <div className="modal__close ico ico-close" onClick={onCloseModal} />
      </ModalComponent>
    );
  }
);

ContactsModal.displayName = "ContactModal";
